import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Col, Row } from "react-bootstrap";
import { getLast7Days } from "../../../utilities/utilies";

const DashboardRevenueGraph = ({ bookingReport }) => {
  // console.log(bookingReport, "--------------------datachk graph");
  const [series, seSeries] = useState([]);
  const options = {
    chart: {
      id: "basic-bar",
    },
    xaxis: {
      categories: getLast7Days(),
    },

    colors: ["#bf0020"],
  };
  useEffect(() => {
    if (bookingReport)
      seSeries(
        bookingReport?.map((item, ind) => {
          return item?.totalCount;
        })
      );
  }, [bookingReport]);

  return (
    <>
      <Row className="justify-content-center">
        <Col lg="12">
          <div className="cardCstm p-3 rounded border">
            <div className="cardHead m-0 pb-2 d-flex align-items-center justify-content-between gap-10">
              <h6 className="m-0 fw-sbold themeBlue">Revenue</h6>
              <p className="text-muted m-0 fw-sbold themeBlue">Last 7 days </p>
            </div>
            <div className="graph">
              <ReactApexChart
                options={options}
                series={[
                  {
                    name: "Revenue",
                    data: series,
                  },
                ]}
                type="bar"
                height={300}
              />
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};
export default DashboardRevenueGraph;
